const PROD_ENDPOINT =
  import.meta.env.VITE_PROD_SERVER || 'https://prod.afx-server.com';
export const VITE_DEV_SERVER =
  import.meta.env.VITE_DEV_SERVER || 'https://dev.afx-server.com';
export const VITE_PROD_SERVER =
  import.meta.env.NODE_ENV === 'production' ? PROD_ENDPOINT : VITE_DEV_SERVER;

export const VITE_DEV_BOT =
  import.meta.env.VITE_DEV_BOT || 'https://dev.afriexdev.com';
export const VITE_STAGING_BOT =
  import.meta.env.VITE_STAGING_BOT || 'https://staging.afriexdev.com';

export const VITE_API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || VITE_DEV_SERVER;

// The public API host, for links the dashboard writes into content that people
// outside the admin open (product update images, read by businesses). Not the
// same as VITE_API_BASE_URL, which in production is the admin's own
// SSO-protected hostname.
export const VITE_PUBLIC_API_BASE_URL =
  import.meta.env.VITE_PUBLIC_API_BASE_URL || VITE_API_BASE_URL;

// Production only: the admin sits behind Cloudflare Access there, and the login
// page signs staff in from their Access identity instead of asking for email,
// password and OTP. Off everywhere else (sandbox, local), which keep that form.
export const VITE_ADMIN_SSO_ENABLED =
  import.meta.env.VITE_ADMIN_SSO_ENABLED === 'true';

export const VITE_TRONSCAN_TRANSACTION_URL =
  'https://tronscan.org/#/transaction/';

/**
 * The production system health dashboard in Datadog.
 *
 * Defined as code in `packages/status-page/src/definitions/dashboard.ts` and
 * updated in place by the status-page apply, so its id stays stable. The same
 * link is right for every Admin environment: the dashboard reads production.
 *
 * Linked rather than embedded, deliberately. Datadog's own login decides who
 * can open it, so access is revoked the moment a Datadog account is disabled.
 * An embed keeps a browser signed in for 30 days with no per-person
 * revocation. The comparison is recorded in issue #6748.
 *
 * `us5.datadoghq.com`, not `app.us5.datadoghq.com`. Both reach the dashboard,
 * but a Datadog login belongs to the hostname it was made on, and the team
 * signs in on `us5.datadoghq.com`; the `app.` form can ask someone who is
 * already signed in to log in again. No query string either: a copied link
 * carries `from_ts`/`to_ts` for one moment, which would pin every visitor to
 * that window instead of the dashboard's live default.
 */
export const SYSTEM_HEALTH_DASHBOARD_URL =
  'https://us5.datadoghq.com/dashboard/8b5-76w-wcm';
